export default __webpack_public_path__ + "static/media/pk.3be8b2e3.jpg";